
export enum AccessorialCheckCd {
	TDC_VS_APT = 'TdcVsApt'}
